import { useCallback, useMemo, useState } from 'react';
import { buildDefaultFilters, buildQueryString, hasActiveFilters } from '../ui/data/filters/filterUtils';

export function useFilterState(filterConfig, initialFilters) {
  const defaults = useMemo(() => buildDefaultFilters(filterConfig), [filterConfig]);

  const [filters, setFilters] = useState(() => ({
    ...defaults,
    ...(initialFilters || {}),
  }));

  const removeFilter = useCallback(
    (key) => {
      const field = filterConfig.find((f) => f.key === key);
      const resetValue = field?.defaultValue ?? (field?.type === 'multi_select' ? [] : 'All');
      setFilters((prev) => {
        const updated = { ...prev, [key]: resetValue };
        if (key === 'status' && 'reviewer' in prev) {
          updated.reviewer = [];
        }
        return updated;
      });
    },
    [filterConfig]
  );

  const clearAllFilters = useCallback(() => {
    setFilters(defaults);
  }, [defaults]);

  const queryString = useMemo(() => buildQueryString(filters), [filters]);

  const activeCount = useMemo(
    () =>
      Object.entries(filters).filter(([, value]) => {
        if (value === null || value === undefined) return false;
        if (value === 'All') return false;
        if (Array.isArray(value)) return value.length > 0;
        return true;
      }).length,
    [filters]
  );

  const isActive = useMemo(() => hasActiveFilters(filters), [filters]);

  return {
    filters,
    setFilters,
    removeFilter,
    clearAllFilters,
    queryString,
    activeCount,
    isActive,
  };
}